import React from 'react'
import { URL_TERMS_OF_USE, URL_PRIVACY_POLICY, URL_SUPPORT } from 'constants/links'

const Footer = () => (
  <div className='flex flex-column pt6 pb10' id='footer'>
    <ul className='list-reset flex justify-center pa0 ma0'>
      <li>
        <a
          className='lite-grey ph6 no-underline hover-underline f6'
          href={URL_PRIVACY_POLICY}
          target='_blank'
          rel='noopener noreferrer'
        >
          Privacy policy
        </a>
      </li>
      <li>
        <a
          className='lite-grey ph6 no-underline hover-underline f6 bl br b--lite-grey'
          href={URL_TERMS_OF_USE}
          target='_blank'
          rel='noopener noreferrer'
        >
          Terms of use
        </a>
      </li>
      <li>
        <a
          className='lite-grey ph6 no-underline hover-underline f6'
          href={URL_SUPPORT}
          target='_blank'
          rel='noopener noreferrer'
        >
          Support
        </a>
      </li>
    </ul>
    <div className='lite-grey tc mt8 f6'>
      &copy;FromCounsel Limited {new Date().getFullYear()}. All rights reserved.
    </div>
  </div>
)

export default Footer
